import styled, { css, keyframes } from "styled-components";
import { ReactComponent as Arrow } from "../../assets/icons/arrow.svg";
import { ReactComponent as ChevronDownSvg } from "../../assets/icons/chevron-down.svg";
const uploadActionStyles = `
  border-radius: 100px;
  background: rgba(0, 0, 0, 0.37);
  backdrop-filter: blur(6.849999904632568px);
  border: 0.5px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  outline: none;
  cursor: pointer;
`;
export const ModalContainer = styled.div`
  width: 100%;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.5);
  max-height: 95dvh;
  max-width: 400px;
  position: relative;
  z-index: 1000;

  display: flex;
  flex-direction: column;
  /* Keep visible so the ExplosionButton glow/explosion in the footer is not clipped */
  overflow: visible;

  border-radius: 24px;
  border: 1px solid #142743;
  background: #142743;
`;
export const Textarea = styled.textarea`
  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;

  resize: vertical;
  min-height: 126px;
  outline: none;
`;

export const ModalTitle = styled.h2`
  font-family: Figtree;
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.1px;
  text-align: left;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;
export const SmallRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
`;
export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const FavoriteButton = styled.div`
  width: 24px;
  height: 24px;
  position: relative;
  z-index: 2;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const Tags = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  flex-wrap: wrap;
  width: 100%;
`;

export const AdminActionsContainer = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  width: 100%;
`;

export const AdminActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 28px;
  padding: 0 12px;
  border-radius: 999px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background: #213d64;
  color: #fff;
  font-family: Figtree;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: -0.06px;
  cursor: pointer;
  transition:
    opacity 0.2s ease,
    background 0.2s ease;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  min-width: ${({ $width }) => $width && `${$width}px`};
  justify-content: center;
  height: 22px;
  padding: 2px 4px;
  background-color: ${({ $selected, $click }) =>
    $selected ? "#345884" : $click ? "#fff" : "#112238"};
  border-radius: 8px;
  cursor: ${(p) => (p.$click ? "pointer" : "default")};
  border: 1px solid #345884;

  font-family: Figtree;
  font-size: 12px;
  font-weight: ${({ $selected }) => ($selected ? "600" : "500")};
  letter-spacing: -0.07px;

  color: ${({ $selected, $click }) =>
    $selected ? "#fff" : $click ? "#112238" : "#fff"};
  &:hover {
    background-color: ${({ $selected, $click }) =>
      $selected ? "#345884" : $click ? "#fff" : "#112238"};
  }
`;

export const CloseButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  color: #fff;

  &:hover {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: center;
  text-align: center;

  /* Content scrolls here so the outer container can keep overflow visible */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const ModalFooter = styled.div`
  flex-shrink: 0;
  padding: 12px 16px 16px;
`;

export const CropButton = styled.button`
  display: flex;
  align-items: center;
  position: absolute;
  top: ${(props) => (props.$compact ? "4px" : "5px")};
  padding: ${(props) => (props.$compact ? "4px" : "6px")};
  outline: none;
  border: none;
  right: ${(props) => (props.$shift ? `calc(5px + ${props.$shift}px)` : "5px")};
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;

  svg {
    width: ${(props) => (props.$compact ? "16px" : "20px")};
    height: ${(props) => (props.$compact ? "16px" : "20px")};
    path {
      stroke: white;
    }
  }
`;

export const ImageContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 240px;
  width: 170px;
  max-width: 170px;
  max-height: 240px;

  background: #0e1c31;
  border-radius: 12px;
`;
export const ImageRelative = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  position: relative;
`;
export const ArrowSvg = styled(Arrow)`
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 5;
  width: 33px;
  height: 33px;
  transform: translate(-50%, -50%);
`;
export const UploadButton = styled.button`
  ${uploadActionStyles}
  border-radius: 100px;
  color: #fff;
  font-family: Figtree;
  font-size: ${(props) => (props.$compact ? "12px" : "14px")};
  font-weight: 400;
  letter-spacing: -0.07px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  height: ${(props) => (props.$compact ? "26px" : "33px")};
  padding: ${(props) => (props.$compact ? "0 8px" : "0 12px")};
  white-space: nowrap;

  @media (max-width: 768px) {
    font-size: ${(props) => (props.$compact ? "12px" : "14px")};
    padding: ${(props) => (props.$compact ? "0 8px" : "0 10px")};
    width: auto;
  }

  @media (max-width: 375px) {
    height: ${(props) => (props.$compact ? "24px" : "28px")};
    font-size: ${(props) => (props.$compact ? "11px" : "13px")};
  }
`;

export const UploadActions = styled.div`
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  z-index: 2;
`;

export const GalleryTriggerButton = styled.button`
  ${uploadActionStyles}
  width: ${(props) => (props.$compact ? "26px" : "33px")};
  min-width: ${(props) => (props.$compact ? "26px" : "33px")};
  height: ${(props) => (props.$compact ? "26px" : "33px")};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    color: #fff;
    ${(props) =>
      props.$compact &&
      `
      width: 14px;
      height: 14px;
    `}
  }

  @media (max-width: 375px) {
    width: ${(props) => (props.$compact ? "22px" : "28px")};
    min-width: ${(props) => (props.$compact ? "22px" : "28px")};
    height: ${(props) => (props.$compact ? "22px" : "28px")};
    svg {
      width: ${(props) => (props.$compact ? "12px" : "14px")};
      height: ${(props) => (props.$compact ? "12px" : "14px")};
    }
  }
`;

export const StyledCheckboxText = styled.div`
  color: #fff;
  text-align: center;
  font-family: Figtree;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: -0.065px;
`;

const shake = keyframes`
  0%, 100% { transform: translateX(0); }
  20% { transform: translateX(-6px); }
  40% { transform: translateX(6px); }
  60% { transform: translateX(-4px); }
  80% { transform: translateX(4px); }
`;

export const TermsCheckbox = styled.div`
  display: flex;
  padding: 6px 8px;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  cursor: pointer;
  border-radius: 12px;
  background: #000;
  ${({ $showOutline }) =>
    $showOutline &&
    css`
      outline: 1px solid #2877d9;
      outline-offset: 1px;
    `}

  ${({ $shake }) =>
    $shake &&
    css`
      animation: ${shake} 0.4s ease-in-out;
    `}
`;

export const Image = styled.img`
  max-width: 100%;
  border-radius: 12px;
  pointer-events: none;
  max-height: 100%;
  /* height: 100%; */
  width: 100%;

  object-fit: contain;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: ${(props) =>
    props.$hideImageContainer ? "transparent" : "#fff2"};
  max-width: 100%;

  border-radius: 12px;
  max-width: 100%;
  max-height: 100%;
`;

export const ModalMessage = styled.p`
  color: #fff;
  text-align: left;
  font-family: Figtree;
  font-size: 15px;
  opacity: 0.4;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  width: 100%;
`;

export const CancelButton = styled.button`
  display: flex;
  width: 110px;
  height: 40px;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 100px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.2);
  outline: none;

  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.4);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ConfirmButton = styled.button`
  display: flex;
  height: 44px;
  padding: 12px 24px;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  gap: 4px;
  flex: 1 0 0;
  border-radius: 100px;
  background: #fff;
  cursor: pointer;
  border: none;
  outline: none;

  font-family: Figtree;
  color: #0f2c32;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.08px;

  white-space: nowrap;
  transition: all 0.3s ease;

  &:disabled {
    cursor: not-allowed;
    pointer-events: none;
  }
`;

export const NudifyContainer = styled.div`
  display: flex;
  padding: 6px 8px;
  background: #0e1c31;
  border-radius: 12px;
  align-items: center;
  cursor: pointer;
  gap: 6px;
  align-self: stretch;
  flex-direction: row;
  height: 33px;

  border-radius: 1000px;
  border: 0.5px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.37);
  backdrop-filter: blur(6.849999904632568px);
`;

export const NudifyText = styled.span`
  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const SettingsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const FadeWrapper = styled.div`
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 48px;
    background: linear-gradient(to right, transparent, #142743);
    pointer-events: none;
    transition: opacity 0.2s ease;
    opacity: ${({ $faded }) => ($faded ? 1 : 0)};
  }
`;

export const LabelText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  text-align: left;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

export const Input = styled.input`
  display: flex;
  height: 44px;
  padding: 12px;
  align-items: center;
  gap: 10px;
  align-self: stretch;

  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #142743;

  font-family: Figtree;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const CheckboxContainerRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  width: 100%;
`;
export const CheckboxContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template-rows: repeat(2, auto);
  gap: 6px;

  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;

  /* optional – lepši scroll */
  padding-bottom: 7px;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    height: 6px;
  }

  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background: #45608d;
  }

  &::-webkit-scrollbar-thumb {
    cursor: grab;
    background: #2877d9;
    border-radius: 20px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #2877d990;
  }
  &::-webkit-scrollbar-thumb:active {
    background: #2877d9;
    cursor: grabbing;
  }
`;

export const Checkbox = styled.div`
  display: flex;
  padding: 4px 8px;
  align-items: center;
  gap: 4px;
  flex: 1 0 0;
  cursor: pointer;
  height: 33px;
  border-radius: 10px;
  background: ${(p) => (p.$checked ? "transparent" : "#0e1c31")};

  border-radius: 1000px;

  background: rgba(0, 0, 0, 0.37);

  border: ${(p) =>
    p.$checked
      ? "0.5px solid #2877d9"
      : "0.5px solid rgba(255, 255, 255, 0.1)"};
`;

export const CheckboxText = styled.span`
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
`;

export const AngleDropdownsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const AngleDropdownWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const AngleDropdownTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border-radius: 12px;
  border: 0.5px solid #325682;
  background: #0e1c31;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  outline: none;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const AngleDropdownChevron = styled(ChevronDownSvg)`
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  transform: ${(p) => (p.$isOpen ? "rotate(180deg)" : "rotate(0deg)")};
  flex-shrink: 0;
`;

export const AngleDropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  right: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  padding: 6px;
  background: #0e1c31;
  border: 0.5px solid #325682;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  max-height: 240px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 20px;
    background: #45608d;
  }
  &::-webkit-scrollbar-thumb {
    background: #2877d9;
    border-radius: 20px;
  }
`;

export const AngleDropdownOption = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  color: #fff;
  font-family: Figtree;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: -0.21px;
  cursor: pointer;
  background: ${(p) => (p.$selected ? "#213d64" : "transparent")};
  transition: background 0.15s ease;

  &:hover {
    background: #213d64;
  }
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  outline: none;
  border: none;
  position: absolute;
  top: ${(props) => (props.$compact ? "4px" : "5px")};
  padding-bottom: 2px;
  left: ${(props) => (props.$shift ? `calc(5px + ${props.$shift}px)` : "5px")};
  border-radius: 100px;
  background: rgba(17, 17, 19, 0.4);
  cursor: pointer;
  justify-content: center;
  z-index: 100;
  width: ${(props) => (props.$compact ? "24px" : "32px")};
  height: ${(props) => (props.$compact ? "24px" : "32px")};

  svg {
    path {
      stroke: white;
    }
  }
`;
